(function(){"use strict";(e=>{const t=document.createElement("style");t.setAttribute("data-vsimple-ui",""),t.textContent=e,document.head.insertBefore(t,document.head.firstChild)})("._v-new-version__content_1v7hk_1{font-family:var(--v-font-primary);margin:0;line-height:21px;font-weight:500;color:var(--v-text-secondary-color);font-size:14px}")})();
const e = {
  "v-new-version__content": "_v-new-version__content_1v7hk_1"
};
export {
  e as default
};
